import { configureStore } from "@reduxjs/toolkit";
import accountingReducer from "./slices/accountingSlice";
import authReducer from './slices/authSlice';
import paycheckReducer from "./slices/paycheckSlice";
import userReducer from './slices/userSlice';

const store = configureStore({
    reducer: {
        auth: authReducer,
        user: userReducer,
        paycheck: paycheckReducer,
        accounting: accountingReducer
    },
    middleware: (getDefaultMiddleware) => {
        const defaultMiddlewares = getDefaultMiddleware({
            thunk: true
        });

        return [
            ...defaultMiddlewares,
        ]
    }
})

export default store;